// Deep imports rather than the `@/features/hazards` barrel. The barrel exports `./data` before
// `./domain`, so a mapper reaching back through it for an enum is evaluated while `./domain` is
// still initialising and sees `undefined` — which makes this module, and anything importing it,
// impossible to load in isolation (KUDO1-9541).
import { HAZARD_MARKERS } from '@/features/hazards/utils/constants';
import { ClosureSubType } from '@/features/hazards/domain/entities/types/entity-sub-type/closures';
import type { Scheme } from '@/features/hazards/domain/entities/types/scheme';

type ClosuresToSchemeMap = Record<ClosureSubType, Scheme>;

export const closuresToSchemeMap: ClosuresToSchemeMap = {
  [ClosureSubType.SchoolClosureEntity]: {
    icon: HAZARD_MARKERS['ew-school-closure'],
  },
  [ClosureSubType.RoadClosureEntity]: {
    icon: HAZARD_MARKERS['ew-road-closure'],
  },
  [ClosureSubType.FacilityOrParkClosureEntity]: {
    icon: HAZARD_MARKERS['ew-facility-or-park-closure'],
  },
};
